import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-6 offset-md-3" }
const _hoisted_2 = { class: "login-form mt-4 p-4" }
const _hoisted_3 = { class: "row g-3" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "col-12 error-placeholder" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = ["disabled"]

import { ref, watch, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import ErrorLabel from "@/components/ui/ErrorLabel.vue";
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageError } from "@/plugins/ws";
import { useToast } from "@/composables/useToast";
import {RootState} from "@/store";

type RestoreSuccessMessage = WebSocketMessageWithFields<'auth-restore', { email: string }>;
type RestoreFailMessage = WebSocketMessageError<'auth-restore-fail'>;

// Объединенный тип для всех сообщений
type RestoreWebSocketMessageType = RestoreSuccessMessage | RestoreFailMessage;


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ComponentsAuthRestore',
},
  __name: 'Restore',
  emits: ["switchMode"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const store = useStore<RootState>();

// Типы для WebSocket сообщений компонента Restore
const internalInstance = getCurrentInstance();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const wsSend = internalInstance?.appContext.config.globalProperties.$wsSend as (signal: string, payload: any) => void;

const email = ref('');
const latestMessageValue = ref(latestMessage);
const disabledSubmit = ref(false);

const setErrorReason = (reason: string) => store.dispatch('errorLabel/setErrorReason', reason);
const unsetErrorReason = () => store.dispatch('errorLabel/unsetErrorReason');

const { showToast } = useToast();

watch(email, () => {
  unsetErrorReason();
});

// WebSocket message handler
const handleWebSocketMessage = (data: RestoreWebSocketMessageType): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'auth-restore':
      signalRestore(data.email);
      break;
    case 'auth-restore-fail':
      signalRestoreFail(data.reason);
      break;
  }
};

watch(latestMessageValue, handleWebSocketMessage);

const handleClickActionRestore = () => {
  wsSend('authRestore', {
    email: email.value,
  });
  disabledSubmit.value = true;
};

const handleClickModeLogin = () => {
  emit('switchMode', 'login');
};

const signalRestore = (email: string) => {
  unsetErrorReason();
  disabledSubmit.value = false;
  store.dispatch('auth/restore', email);
  showToast('Письмо отправлено', 'Проверьте почту для восстановления', 5000);
  emit('switchMode', 'restoreCode');
};

const signalRestoreFail = (payload: string) => {
  setErrorReason(payload);
  disabledSubmit.value = false;
  showToast('Ошибка восстановления', payload, 15000);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("h4", null, "Восстановить аккаунт", -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("label", null, "Почта", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "email",
            name: "email",
            class: "form-control",
            placeholder: "Email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event))
          }, null, 512), [
            [_vModelText, email.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(ErrorLabel)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-dark float-end",
            onClick: handleClickActionRestore,
            disabled: disabledSubmit.value
          }, "Восстановить", 8, _hoisted_7)
        ])
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("hr", { class: "mt-4" }, null, -1)),
      _createElementVNode("div", { class: "col-12 mode-switcher-placeholder" }, [
        _createElementVNode("p", { class: "text-center mb-0" }, [
          _cache[3] || (_cache[3] = _createTextVNode("Есть аккаунт? ")),
          _createElementVNode("a", {
            href: "#",
            onClick: handleClickModeLogin,
            "data-mode": "login"
          }, "Войти")
        ])
      ])
    ])
  ]))
}
}

})